module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAPlJREFUWEftlk0SgyAMhcPGY7hte0rxlO2aY7CxZabMUIXwEhjsQpca8j7yZwyd/JiT9ekCOETgNU/bRrQ+nLc90/OcJ2uIlrvzP5oHgGjYEyL6/IjZm/NrerFsDfSE4MQDSLEIe0DUxFmA8LEFAhGvAmghUHEIQAohjRo8iBDHiM2+tWGAWiQ04nAKUuqSUHgf7KQDTBSBCKK9bW6yqgBq6ZCM8GaAINYytlUAaQq+hbRoIcQAufy31IQIgBPSQsAAyHjVQEAAiLi2RasAmltJzrAAEkf73kfPDllIuBYdtpKVIIYupTmI/1vLJT+SHrbVNuwhwvm4AN4VXf0hKaMVAAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/close.png
// module id = JA1j
// module chunks = 1